import { VehicleMaintenanceState } from './vehicle-maintenance.interfaces';
import { initialState } from './maintenance-schedule/maintenance-schedule.interfaces';
import { initialState as initState } from './services-due/services-due.interfaces';
import { initialState as templatedetailInitialState } from './template-detail/template-detail.interfaces';
import { initialState as acceptedInitialState } from './accepted-services/accepted-services.interfaces';
import { initialState as declinedInitialState } from './declined-services/declined-services.interfaces';
// eslint-disable-next-line max-len
import { initialState as pendingAcceptedInitialState } from './pending-accepted-services/pending-accepted-services.interfaces';
// eslint-disable-next-line max-len
import { initialState as pendingDeclinedInitialState } from './pending-declined-services/pending-declined-services.interfaces';
export const vehicleMaintenanceInitialState: VehicleMaintenanceState = {
  maintenanceSchedule: initialState,
  templates: {},
  templateDetail: templatedetailInitialState,
  servicesDue: initState,
  openedFromTransaction: { id: null, source: null },
  acceptedServices: acceptedInitialState,
  declinedServices: declinedInitialState,
  pendingAcceptedServices: pendingAcceptedInitialState,
  pendingDeclinedServices: pendingDeclinedInitialState
  // fill it initial state here
};
